import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { assessmentService } from "../../services/assessmentService";
import { UserAssessmentPermission } from "../../models/PermissionModel";
import { setUserAssessmentPermission } from "../../redux/ducks/user-permission";

/** Custom hook to get the assessment permissions based on the assessmentId
 *  @param assessmentId A string guid value
*/
function useAssessmentPermissions(assessmentId: string) {
    const dispatch = useDispatch();

    // Always refresh permissions on mount so stale Redux state from a previous
    // assessment never causes an already-published assessment to show the Publish button.
    useEffect(() => {
        getAssessmentPermission();
    }, [])

    // get an assessment permission for user
    const getAssessmentPermission = () => {
        if (!assessmentId) return;

        assessmentService
            .getPermission(assessmentId, true)
            .then((permission: UserAssessmentPermission) => {
                if (permission) dispatch(setUserAssessmentPermission(permission));
            })
            .catch(() => {});
    };
}

export default useAssessmentPermissions;